export default function AppEntry() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-12">
          <div className="flex-shrink-0">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-2xl bg-accent-100 flex items-center justify-center overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20mobile%20app%20icon%20design%20for%20anime%20streaming%20platform%2C%20minimalist%20flat%20design%20with%20play%20button%20motif%20and%20cherry%20blossom%20accent%2C%20warm%20pink%20and%20white%20color%20scheme%2C%20modern%20UI%20style%2C%20simple%20geometric%20shapes&width=400&height=400&seq=app-entry-01&orientation=squarish"
                alt="樱花动漫手机客户端"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">移动追番</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
              樱花动漫手机客户端已上线，支持 iOS 与 Android 双平台。
              高清画质、倍速播放、离线缓存、弹幕互动，随时随地畅享动漫世界。
              新用户注册即享 7 天 VIP 体验，追番更加畅快。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 下载
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-6 py-2.5 border border-foreground-300 text-foreground-700 rounded-full text-sm font-medium hover:border-primary-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}